/*
 * Visualiseur InstrumenPoche en Javascript et SVG
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const ActionAncetre = require('./actionAncetre')
const mathjaxLoader = require('../mathjaxLoader')

module.exports = ActionNommerPoint

/**
 * Action donnant un nom à un point
 * @extends iep.actionAncetre
 * @constructor
 * @param {ie.iepDoc} doc : le doculent propriétaire
 * @param {iep.nomPoint} objet :  l'objet représentant le nom
 * @param {string} tempo : le tempk en dixièmes de seconde (ou null)
 */
function ActionNommerPoint (doc, objet, tempo) {
  ActionAncetre.call(this, doc, tempo)
  this.nomPoint = objet
}
ActionNommerPoint.prototype = new ActionAncetre()

/**
 * Appelée par creeActions, précharge Mathjax si besoin et prépare son div de rendu
 */
ActionNommerPoint.prototype.prepare = function () {
  if (this.nomPoint.estLatex) {
    this.nomPoint.div = document.createElement('div')
    // On diminue la taille pour le LaTeX eet on ne spécifie pas la taille en px
    // différence par rapport à MathGraph32
    this.nomPoint.div.setAttribute('style', 'top:0px;left:0px;position:absolute;font-size:' +
      String(this.nomPoint.taille - 2) + 'px;visibility:hidden;')
    this.nomPoint.div.setAttribute('id', this.nomPoint.id + 'iepprov')
    const ch = '$$' + this.nomPoint.nom.substring(1) + '$'
    this.nomPoint.div.appendChild(document.createTextNode(ch))
    document.body.appendChild(this.nomPoint.div)
    // la suite est async
    const self = this
    mathjaxLoader().then(() => {
      /* global MathJax */
      // MathJax.Hub.Typeset(this.div);
      MathJax.Hub.Queue(['Typeset', MathJax.Hub, self.nomPoint.div])
      MathJax.Hub.Queue([function () {
        self.nomPoint.creegLatex()
        self.setReady()
      }])
    }).catch(error => {
      console.error(Error('Mathjax n’a pas été chargé correctement, impossible d’afficher le point en LaTeX'), error)
    })
  } else {
    this.nomPoint.creeg()
    this.setReady()
  }
}

/**
 * Exécutant de l'action donnant un nom au point
 * @param {boolean} immediat : Si true pas de passage à l'action suivante
 */
ActionNommerPoint.prototype.execute = function (immediat) {
  // if ((this.nomPoint.objet === "point") && !this.nomPoint.nomCree) {
  if (this.nomPoint.objet === 'point') {
    // this.nomPoint.creeg();
    this.nomPoint.positionne()
    const point = this.nomPoint.point
    if (point.nom !== null) { this.doc.svg.replaceChild(this.nomPoint.g, point.nom.g) } else this.doc.svg.appendChild(this.nomPoint.g)
    point.nom = this.nomPoint
  }
  this.nomPoint.g.setAttribute('visibility', 'visible')
  if (!immediat) this.doc.actionSuivante(immediat)
}

/** @inheritDoc */
ActionNommerPoint.prototype.actionVisible = function () {
  return this.doc.getObjectVisibility(this.nomPoint.point, this.indice - 1)
}
